"use client";

import { Monitor, BookOpen, MapPin, Users } from "lucide-react";

const cards = [
  {
    title: "In Class",
    icon: <BookOpen className="w-6 h-6 text-[#00AEEF]" />,
    items: [
      "Pre Leads",
      "Lecture",
      "Discussions & Debates",
      "Case Studies",
      "Reports",
      "Group Activities",
      "Class Assignments",
      "Role Play & Simulations",
    ],
  },
  {
    title: "Online",
    icon: <Monitor className="w-6 h-6 text-[#00AEEF]" />,
    items: [
      "Pre Leads",
      "Lecture",
      "Discussions & Debates",
      "Case Studies",
      "Reports",
      "Group Activities",
      "Class Assignments",
      "Role Play & Simulations",
    ],
  },
  {
    title: "On Field",
    icon: <MapPin className="w-6 h-6 text-[#00AEEF]" />,
    items: [
      "Pre Leads",
      "Lecture",
      "Discussions & Debates",
      "Case Studies",
      "Reports",
      "Group Activities",
      "Class Assignments",
      "Role Play & Simulations",
    ],
  },
  {
    title: "In campus & Community",
    icon: <Users className="w-6 h-6 text-[#00AEEF]" />,
    items: [
      "Pre Leads",
      "Lecture",
      "Discussions & Debates",
      "Case Studies",
      "Reports",
      "Group Activities",
      "Class Assignments",
      "Role Play & Simulations",
    ],
  },
];

export default function EngagingEffective() {
  return (
    <section className="bg-[#081E2D] py-8 md:py-16">
      <div className="page-container mx-auto">
        {/* Header */}
        <div className="mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Easy – Engaging – Effective
          </h2>
          <p className="text-gray-300 text-sm md:text-base lg:text-lg max-w-3xl leading-relaxed">
            Your edge at Medhavi Skills University—where real-world learning,
            industry exposure, and future-ready skills come together
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {cards.map((card, index) => (
            <div key={index} className="flex flex-col shadow-xl">
              {/* Card Header */}
              <div className="bg-[#007AB9] p-5 flex items-center gap-4">
                <div className="bg-white p-2 rounded-full shrink-0">
                  {card.icon}
                </div>
                <h3 className="text-white font-bold text-lg md:text-xl">
                  {card.title}
                </h3>
              </div>

              {/* Card Body */}
              <div className="bg-white p-6 flex-grow">
                <ul className="space-y-3">
                  {card.items.map((item, idx) => (
                    <li
                      key={idx}
                      className="flex items-center gap-3 text-gray-800"
                    >
                      <span className="w-1.5 h-1.5 bg-black rounded-full shrink-0" />
                      <span className="text-sm md:text-base font-medium">
                        {item}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
